/**
 * Configure your Gatsby site with this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-config/
 */

/**
 * @type {import('gatsby').GatsbyConfig}
 */
module.exports = {
  siteMetadata: {
    title: `Travel with Amnet`,
    description: `Explore Japan with Amnet's private tours. Get customized, expert-planned Japan group tours for an unforgettable experience. Book your adventure today!`,
    author: `Amnet New York, Inc.`,
    siteUrl: `https://travelwithamnet.com/`,
  },
  plugins: [
    `gatsby-plugin-postcss`,
    `gatsby-plugin-image`,
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/images`,
      },
    },
    `gatsby-transformer-sharp`,
    `gatsby-plugin-sharp`,
    // {
    //   resolve: `gatsby-plugin-manifest`,
    //   options: {
    //     name: `gatsby-starter-default`,
    //     short_name: `starter`,
    //     start_url: `/`,
    //     background_color: `#663399`,
    //     // This will impact how browsers show your PWA/website
    //     // https://css-tricks.com/meta-theme-color-and-trickery/
    //     // theme_color: `#663399`,
    //     display: `minimal-ui`,
    //     icon: `src/images/amnet-icon.png`, // This path is relative to the root of the site.
    //   },
    // },
    {
      resolve: 'gatsby-source-storyblok',
      options: {
        accessToken: process.env.STORYBLOK_ACCESS_TOKEN,
        region: 'us',
        version: process.env.STORYBLOK_VERSION === 'published' ? 'published' : 'draft',
        localAssets: true, // Optional parameter to download the images to use with Gatsby Image Plugin
        resolveRelations: [
          "relatedTourItem.tourAdItems", "reviewSection.reviews", "review.tour", 
          "blogArticle.category", "tourItem.prefecture", "blogArticle.sideTourItem", "prefectureItem.popularTours",
          "megaMenuTour.tour", "landingTourPackages.tours", "landingTourRow.tour", "landingTourBanners.tours",
          "relatedArticles.articles","luxuryTours.tours","luxuryAccommodations.accommodations",
          "relatedBlogArticle.article"
        ]
        // languages: ['de', 'at'] // Optional parameter. Omission will retrieve all languages by default.
      }
    },
    // this (optional) plugin enables Progressive Web App + Offline functionality
    // To learn more, visit: https://gatsby.dev/offline
    // `gatsby-plugin-offline`,
    // {
    //   resolve: `gatsby-source-graphql`,
    //   options: {
    //     fieldName: `Storyblok`,
    //     typeName: `storyblok`,
    //     url: `https://gapi-us.storyblok.com/v1/api`,
    //     headers: {
    //       Token: process.env.STORYBLOK_ACCESS_TOKEN,
    //       Version: `draft`,
    //     },
    //   },
    // }
    {
      resolve: `gatsby-plugin-google-gtag`,
      options: {
        trackingIds: [
          "G-9JEPRYJKZ6", // Google Analytics / GA
        ],
        pluginConfig: {
          // Puts tracking script in the head instead of the body
          head: true
        },
      }
    },
    {
      resolve: "gatsby-plugin-google-tagmanager",
      options: {
        id: "GTM-MDGDS6JB",
        includeInDevelopment: false,
      }
    },
    {
      resolve: `gatsby-plugin-hotjar`,
      options: {
        id: 3758753,
        sv: 6,
      },
    },
    {
      resolve: `gatsby-plugin-canonical-urls`,
      options: {
        siteUrl: `https://travelwithamnet.com`,
        stripQueryString: true,
      },
    },
    {
      resolve: "gatsby-plugin-cookiebot",
      options: {
        cookiebotId: "2321c47d-884d-4e0d-b09c-b2bb0d5a9296", // Required. Site's Cookiebot ID.
        manualMode: true, // Optional. Turns on Cookiebot's manual mode. Defaults to false.
        blockGtm: false, //  Optional. Skip blocking of GTM. Defaults to true if manualMode is set to true.
        includeInDevelopment: false, // Optional. Enables plugin in development. Will cause gatsby-plugin-google-tagmanager to thrown an error when pushing to dataLayer. Defaults to false.
      },
    },
  ],
}
